/* MXDVS window motion: Shopify asset assets/mxdvs-window-motion.js (11.10.2026)
   Goes with assets/mxdvs-window-motion.css (the cart's Stack + Decode on the other windows).
   Each window keeps its own open and close code; this file only watches for it:
   - on open: the rows fall into line (class mxw-in for a moment) and titles decode
     (only where the window does not decode its own text already)
   - on close: the titles scramble away
   - phones: drag down or slide left to close (25% of the way or a quick flick); the first
     6px decide the direction. The product panel already closes downwards with
     assets/mxdvs-sheet-drag.js, so it only gets the slide left here. The cookie window
     gets no swipe: closing it needs a choice.
   - round 2: the country list (phone list and desktop window), the menu drawer, the search and
     the photo zoom. Their sheets move with the CSS property translate (their own rules fix
     transform with !important), so the drag uses translate too (option tr).
   12.10.2026 (MOBILE 2): while the menu sheet is dragged down, one blur strip (.mxm-dragveil, styles in
   assets/mxdvs-menu-sheet.css) grows from the top of the window down to the sheet, so the whole page stays
   blurred. Only that strip changes height while dragging (option A "Follow"). 13.10.2026: it is the only blur
   layer while dragging (the strip above the sheet hides), so there is no double layer.
   Loaded on every page by sections/mxdvs-menu-terminal.liquid. */
(function () {
  if (window.MxWin) return;
  var M = (window.MxWin = {});
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  M.ms = function () {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mxw-open'));
    return v > 0 ? v : 500;
  };

  var WINDOWS = [
    {
      root: '.pp-layer',
      isOpen: function (r) { return r.classList.contains('is-open'); },
      box: '.pp-dialog',
      dec: '.pp-dialog__title, .pp-h',
      close: function (r) { var b = r.querySelector('[data-close]'); if (b) b.click(); },
      down: false,
      left: true
    },
    {
      root: '.mxnl',
      isOpen: function (r) { return r.classList.contains('is-open'); },
      box: '.mxnl-wrap',
      dec: '',
      close: function (r) { var b = r.querySelector('[data-mxnl-act="close"]'); if (b) b.click(); },
      down: true,
      left: true
    },
    {
      root: '.mxcc-wrap',
      isOpen: function (r) { return r.classList.contains('is-in') && !r.classList.contains('is-gone') && !r.classList.contains('is-dim'); },
      box: null,
      dec: '',
      close: null,
      down: false,
      left: false
    },
    {
      /* Country list: before the menu, because the phone list sits inside the menu sheet */
      root: '.disclosure__list-wrapper.country-selector',
      isOpen: function (r) { return r.classList.contains('is-open') && !r.classList.contains('is-fading'); },
      box: null,
      dec: '',
      close: function (r) { var b = r.querySelector('.country-selector__close-button'); if (b) b.click(); },
      down: true,
      left: true,
      tr: true,
      inner: true
    },
    {
      /* Menu drawer (phones and tablets): open = menu-opening, the X adds is-fading-out first */
      root: '#Details-menu-drawer-container',
      isOpen: function (r) {
        var d = r.querySelector('#menu-drawer');
        return r.classList.contains('menu-opening') && !(d && d.classList.contains('is-fading-out'));
      },
      box: '#menu-drawer',
      dec: '.menu-drawer__title, .menu-drawer__navigation > .menu-drawer__menu > li > a, .menu-drawer__navigation > .menu-drawer__menu > li > details > summary',
      close: function (r) { var b = r.querySelector('.menu-drawer__close-x'); if (b) b.click(); },
      down: true,
      left: true,
      tr: true,
      inner: true,
      deep: true
    },
    {
      /* Search: open = details[open], the close fade sets is-closing on the details-modal */
      root: 'details-modal.header__search',
      isOpen: function (r) { var d = r.querySelector('details'); return !!d && d.open && !r.classList.contains('is-closing'); },
      box: '.search-modal__content',
      dec: '',
      close: function (r) { var b = r.querySelector('.search-modal__close-button'); if (b) b.click(); },
      down: true,
      left: true,
      tr: true,
      inner: true,
      attrs: ['open'],
      reset: 800
    },
    {
      /* Photo zoom (made on first use by assets/mxdvs-product.js, which stays as it is) */
      root: '.pp-lb',
      isOpen: function (r) { return r.classList.contains('is-on'); },
      box: 'img',
      dec: '',
      close: function (r) { var b = r.querySelector('.pp-close'); if (b) b.click(); },
      down: true,
      left: true,
      tr: true,
      hit: 'root'
    }
  ];

  /* ---------- Decode: letters and digits scramble, then settle (out = scramble away) ---------- */
  var POOL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#%&*';
  M.decode = function (root, sel, out) {
    if (RM || !sel) return;
    var ms = M.ms() * (out ? 0.6 : 1.2);
    var nodes = [];
    root.querySelectorAll(sel).forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        if (!n.nodeValue.trim()) continue;
        if (n._mxOrig == null) n._mxOrig = n.nodeValue;
        nodes.push({ n: n, t: n._mxOrig, d: n._mxOrig.split('').map(function () { return Math.random(); }) });
      }
    });
    if (!nodes.length) return;
    var run = (root._mxwRun = (root._mxwRun || 0) + 1);
    var t0 = performance.now();
    (function step(now) {
      if (run !== root._mxwRun) return;
      var p = Math.min(1, (now - t0) / ms);
      nodes.forEach(function (o) {
        if (p >= 1) { o.n.nodeValue = o.t; return; }
        o.n.nodeValue = o.t.split('').map(function (ch, i) {
          if (!/[A-Za-z0-9]/.test(ch)) return ch;
          var scrambled = out ? p > o.d[i] * 0.5 : p < 0.3 + o.d[i] * 0.7;
          if (!scrambled) return ch;
          return /[0-9]/.test(ch) ? String(Math.floor(Math.random() * 10)) : POOL[Math.floor(Math.random() * POOL.length)];
        }).join('');
      });
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  };

  /* ---------- Watch each window's own open state ---------- */
  function opened(def, el) {
    if (RM) return;
    clearTimeout(el._mxwO);
    el.classList.remove('mxw-out');
    el.classList.add('mxw-in');
    clearTimeout(el._mxwT);
    el._mxwT = setTimeout(function () { el.classList.remove('mxw-in'); }, M.ms() * 2.5);
    M.decode(el, def.dec, false);
  }
  function closed(def, el) {
    clearTimeout(el._mxwT);
    el.classList.remove('mxw-in');
    if (!RM) {
      // The rows drop out first (mxw-out), then the class goes once the window is shut
      el.classList.add('mxw-out');
      clearTimeout(el._mxwO);
      el._mxwO = setTimeout(function () { el.classList.remove('mxw-out'); }, 900);
    }
    M.decode(el, def.dec, true);
  }
  function watch(def, el) {
    if (el._mxw) return;
    el._mxw = true;
    var was = def.isOpen(el);
    new MutationObserver(function () {
      var now = def.isOpen(el);
      if (now === was) return;
      was = now;
      if (now) opened(def, el);
      else closed(def, el);
    }).observe(el, { attributes: true, attributeFilter: ['class'].concat(def.attrs || []), subtree: !!def.deep || !!def.attrs });
  }
  function scan(scope) {
    WINDOWS.forEach(function (def) {
      if (scope.matches && scope.matches(def.root)) watch(def, scope);
      if (scope.querySelectorAll) scope.querySelectorAll(def.root).forEach(function (el) { watch(def, el); });
    });
  }
  function start() {
    scan(document);
    /* The product panels are made on first use and added to the body */
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* ---------- Phones: drag down or slide left to close ---------- */
  function phone() { return window.innerWidth < 990; }
  // A row that scrolls sideways (a wide size table) keeps its own sideways swipe
  function sideScroll(t, stop) {
    for (var n = t; n && n !== stop; n = n.parentElement) {
      if (n.scrollWidth > n.clientWidth + 1) {
        var o = getComputedStyle(n).overflowX;
        if (o === 'auto' || o === 'scroll') return true;
      }
    }
    return false;
  }
  // A scroller inside the window that is not at its top keeps its own scroll
  function atTop(t, stop) {
    for (var n = t; n; n = n.parentElement) {
      if (n.scrollHeight > n.clientHeight + 1) {
        var o = getComputedStyle(n).overflowY;
        if ((o === 'auto' || o === 'scroll') && n.scrollTop > 0) return false;
      }
      if (n === stop) break;
    }
    return true;
  }
  var g = null;
  document.addEventListener('touchstart', function (e) {
    g = null;
    if (!phone() || e.touches.length !== 1) return;
    var t = e.target;
    if (!t || !t.closest || t.closest('input, textarea, select')) return;
    for (var i = 0; i < WINDOWS.length; i++) {
      var def = WINDOWS[i];
      if (!def.down && !def.left) continue;
      var root = t.closest(def.root);
      if (!root || !def.isOpen(root)) continue;
      var box = def.box ? root.querySelector(def.box) : root;
      if (!box || (def.hit !== 'root' && !box.contains(t))) continue;
      g = {
        def: def, root: root, box: box,
        x0: e.touches[0].clientX, y0: e.touches[0].clientY,
        dd: 0, last: 0, lastT: performance.now(), v: 0, on: false, axis: '',
        canLeft: def.left && !sideScroll(t, box),
        canDown: def.down && (def.inner ? atTop(t, box) : box.scrollTop <= 0)
      };
      return;
    }
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!g) return;
    var x = e.touches[0].clientX;
    var y = e.touches[0].clientY;
    var dx = x - g.x0;
    var dy = y - g.y0;
    if (!g.on) {
      if (g.canLeft && dx < -6 && Math.abs(dx) > Math.abs(dy) * 1.5) g.axis = 'x';
      else if (g.canDown && dy > 6 && Math.abs(dy) > Math.abs(dx)) g.axis = 'y';
      else if (Math.abs(dx) > 6 || Math.abs(dy) > 6) { g = null; return; }
      else return;
      g.on = true;
      g.last = g.axis === 'x' ? x : y;
      g.box.classList.add('is-drag');
      if (isMenu(g)) veilStart(g);
    }
    // This window's drag only: the page and other drag handlers stay out of it
    e.stopPropagation();
    if (e.cancelable) e.preventDefault();
    var pos = g.axis === 'x' ? x : y;
    g.dd = g.axis === 'x' ? Math.min(0, dx) : Math.max(0, dy);
    var now = performance.now();
    g.v = (pos - g.last) / Math.max(1, now - g.lastT);
    g.last = pos;
    g.lastT = now;
    if (g.def.tr) g.box.style.translate = g.axis === 'x' ? g.dd + 'px 0' : '0 ' + g.dd + 'px';
    else g.box.style.transform = g.axis === 'x' ? 'translateX(' + g.dd + 'px)' : 'translateY(' + g.dd + 'px)';
    if (g.veil) g.veil.style.height = (g.vb + g.dd) + 'px';
  }, { capture: true, passive: false });

  /* The menu sheet dragged down: a blur strip fills the gap above it (12.10.2026) */
  function isMenu(s) {
    return s.def.root === '#Details-menu-drawer-container' && s.axis === 'y';
  }
  function veilStart(s) {
    var v = s.root.querySelector(':scope > .mxm-dragveil');
    if (!v) {
      v = document.createElement('div');
      v.className = 'mxm-dragveil';
      v.setAttribute('aria-hidden', 'true');
      s.root.insertBefore(v, s.box);
    }
    clearTimeout(v._mxmT);
    v.classList.remove('is-snap', 'is-out');
    // 13.10.2026: one blur layer only. The strip takes over the blur above the sheet (from the top of the
    // window) and the container's own ::before strip hides in the same frame, so there is no seam.
    s.vb = Math.max(0, s.box.getBoundingClientRect().top + 5);
    v.style.top = '0px';
    v.style.height = s.vb + 'px';
    v.classList.add('is-on');
    s.root.classList.add('mxm-veiling');
    s.veil = v;
  }
  function veilEnd(s, closing, size) {
    var v = s.veil;
    if (!v) return;
    var root = s.root;
    v.classList.add(closing ? 'is-out' : 'is-snap');
    v.style.height = (s.vb + (closing ? size : 0)) + 'px';
    v._mxmT = setTimeout(function () {
      root.classList.remove('mxm-veiling');
      v.classList.remove('is-on', 'is-snap', 'is-out');
      v.style.height = '0px';
    }, closing ? 700 : 300);
  }

  function end() {
    var s = g;
    g = null;
    if (!s || !s.on) return;
    var box = s.box;
    box.classList.remove('is-drag');
    var size = s.axis === 'x' ? box.offsetWidth : box.offsetHeight;
    var flick = s.axis === 'x' ? s.v < -0.6 : s.v > 0.6;
    var tr = s.def.tr;
    function put(v) {
      if (tr) box.style.translate = s.axis === 'x' ? v + 'px 0' : '0 ' + v + 'px';
      else box.style.transform = s.axis === 'x' ? 'translateX(' + v + 'px)' : 'translateY(' + v + 'px)';
    }
    if (Math.abs(s.dd) > (size || 1) * 0.25 || flick) {
      veilEnd(s, true, size);
      if (tr) box.classList.add('mxw-snap');
      else box.style.transition = RM ? 'none' : 'transform 252ms cubic-bezier(.2,.8,.2,1)';
      put(s.axis === 'x' ? -size : size);
      setTimeout(function () {
        s.def.close(s.root);
        // Put the position back once the closed window is hidden
        setTimeout(function () {
          if (tr) {
            box.classList.remove('mxw-snap');
            box.classList.add('is-drag');
            box.style.translate = '';
            void box.offsetWidth;
            box.classList.remove('is-drag');
          } else {
            box.style.transition = 'none';
            box.style.transform = '';
            void box.offsetWidth;
            box.style.transition = '';
          }
        }, s.def.reset || 400);
      }, RM ? 0 : 280);
    } else {
      veilEnd(s, false, size);
      if (tr) {
        box.classList.add('mxw-snap');
        box.style.translate = '0px 0px';
        setTimeout(function () { box.classList.remove('mxw-snap'); box.style.translate = ''; }, 280);
      } else {
        box.style.transition = 'transform 280ms cubic-bezier(.2,.8,.2,1)';
        box.style.transform = '';
        setTimeout(function () { box.style.transition = ''; }, 280);
      }
    }
  }
  document.addEventListener('touchend', end, { capture: true, passive: true });
  document.addEventListener('touchcancel', end, { capture: true, passive: true });
})();
